export type Bank = string;

export const FLAG_STALE = 1;
export const FLAG_LOW_COVERAGE = 2;
export const FLAG_CARRIED = 4;
export const FLAG_PROVISIONAL = 8;

export interface BankInfo {
    bank: Bank;
    name: string;
    rateName: string;
    anchorKind: string;
    decisionTz: string;
    seriesSlug: string;
}

export interface BinLink {
    levelBp: number;
    deltaBp: number;
    conditionId: string;
    label: string;
}

export interface FinalReading {
    ts: number;
    p: number[];
    impliedBp: number;
    anchorBp: number;
    pendingBp: number;
}

export interface Meeting {
    decisionTs: number;
    decidedBp: number | null;
    meetingDate: string;
    label: string | null;
    eventId: string | null;
    eventSlug: string | null;
    bins: BinLink[];
    final: FinalReading | null;
}

export interface PiprHistory {
    ts: number[];
    n: number;
    deltas: number[];
    anchorBp: number[];
    pendingBp: number[];
    impliedBp: number[];
    p: number[][];
    meetingIdx: number[];
    flags: number[];
}

export interface ForwardMeeting {
    decisionTs: number;
    p: number[];
    rateBp: number;
    baseBp: number;
}

export interface PiprForward {
    asofTs: number;
    anchorBp: number;
    pendingBp: number;
    pendingAnnouncedTs: number | null;
    pendingEffectiveTs: number | null;
    deltas: number[];
    meetings: ForwardMeeting[];
}

export interface PiprBundle {
    schemaVersion: number;
    methodologyVersion: string;
    bank: Bank;
    banks: BankInfo[];
    generatedTs: number;
    bucketSec: number;
    historyStartTs: number;
    firstCutTs: number;
    lastCutTs: number;
    meetings: Meeting[];
    history: PiprHistory;
    forward: PiprForward;
}

export const SUPPORTED_SCHEMA = 1;

export interface BankLabel {
    short: string;
    code: string;
    symbol: string;
}

const BANK_LABELS: Record<string, BankLabel> = {
    fed: { short: 'Fed', code: 'USD', symbol: '$' },
    ecb: { short: 'ECB', code: 'EUR', symbol: '€' },
};

export function bankLabel(bank: Bank): BankLabel {
    return (
        BANK_LABELS[bank] ?? {
            short: bank.toUpperCase(),
            code: bank.toUpperCase(),
            symbol: '',
        }
    );
}

export function indicatorName(bank: Bank): string {
    return `${bankLabel(bank).short} PIPR`;
}
